import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '@/core/services/open-api/api.service';
import { SILENT_API_ERROR_CODES } from '@/core/services/interceptors/error.interceptor';
import {
    TimeBudget,
    TimeBudgetCreateRequestDto,
    TimeBudgetErrorCode,
    TimeBudgetUpdateRequestDto,
} from '@/core/models/time-budget';

/**
 * @class TimeBudgetRepository
 * @description Encapsulates raw API communication for time budgets. There is no delete; a budget is switched off.
 */
@Injectable({ providedIn: 'root' })
export class TimeBudgetRepository extends ApiService {
    constructor(http: HttpClient) {
        super(http);
    }

    /**
     * @param tileIds Only budgets on these tiles. Leave out for all budgets.
     */
    public list(tileIds?: number[]): Observable<TimeBudget[]> {
        const url = ApiService.privateApiUrl + 'time-budgets';
        // TBG-006/007: the cached account is outdated, an admin has turned budgets off since it was loaded.
        // No error toast: TimeBudgetService reloads the account, and its new settings hide the budget column.
        const context = new HttpContext().set(SILENT_API_ERROR_CODES, [
            TimeBudgetErrorCode.Disabled,
            TimeBudgetErrorCode.NotVisibleToAllUsers,
        ]);
        if (tileIds === undefined) {
            return this._http.get<TimeBudget[]>(url, { context });
        }
        return this._http.get<TimeBudget[]>(url, { context, params: { tileIds: tileIds.join(',') } });
    }

    public create(request: TimeBudgetCreateRequestDto): Observable<TimeBudget> {
        return this._http.post<TimeBudget>(ApiService.privateApiUrl + 'time-budgets', request);
    }

    public update(timeBudgetId: number, changes: TimeBudgetUpdateRequestDto): Observable<TimeBudget> {
        return this._http.patch<TimeBudget>(ApiService.privateApiUrl + 'time-budgets/' + timeBudgetId, changes);
    }
}
